import { FilterMapping } from '../models';
import { GridFilters } from '../DataState';

export class FilterMapper<TItem extends object, TFilter> {
  map(gridFilters: GridFilters<TItem>, mapping: FilterMapping<TItem, TFilter>): TFilter {
    const res: TFilter = {} as TFilter;
    gridFilters.forEach((filter) => {
      const newId = mapping[filter.id as keyof TItem];
      if (newId) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        res[newId] = filter.value;
      }
    });
    return res;
  }

  mapToGrid(src: TFilter, mapping: FilterMapping<TItem, TFilter>): GridFilters<TItem> {
    return Object.entries(src as {}).map(([key, value]) => {
      const indexId = Object.values(mapping).findIndex((item) => item === key);
      return {
        id: Object.keys(mapping)[indexId],
        value,
      };
    });
  }
}
